import React from 'react'
import style from "css/template.module.css";
import { Link } from 'react-router-dom';

function MobileSmartDevice() {
    return (
        <section className={style.smart_device_list}>
            <Link
                className={`${style.smart_device_item} ${style.column}`}
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/bar2`}
            >
                <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/swiper_bar_pro.png`}
                    alt=""
                />
                <p>neat.bar Generation2</p>
            </Link>
            <Link
                className={`${style.smart_device_item} ${style.column}`}
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/barPro`}
            >
                <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/swiper_bar_2.png`}
                    alt=""
                />
                <p>neat.bar pro</p>
            </Link>
            <Link
                className={`${style.smart_device_item} ${style.row}`}
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/boardPro`}
            >
                <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/swiper_board_pro.png`}
                    alt=""
                />
                <p>neat.board pro</p>
            </Link>
            <Link
                className={`${style.smart_device_item} ${style.row}`}
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/board50`}
            >
                <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/swiper_board_50.png`}
                    alt=""
                />
                <p>neat.board 50</p>
            </Link>
            <Link
                className={`${style.smart_device_item} ${style.row}`}
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/frame`}
            >
                <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/swiper_frame.png`}
                    alt=""
                />
                <p>neat.frame</p>
            </Link>
            <Link
                className={`${style.smart_device_item} ${style.row}`}
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/center`}
            >
                <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/swiper_center.png`}
                    alt=""
                />
                <p>neat.center</p>
            </Link>
            <Link
                className={`${style.smart_device_item} ${style.column}`}
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/pad`}
            >
                <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/swiper_pad.png`}
                    alt=""
                />
                <p>neat.pad</p>
            </Link>
        </section>
    )
}

export default MobileSmartDevice
